import { http } from '@/libs/util'
import util from '@/libs/util'
const { 
    contract_type_save,
    contract_type_list,
    contract_type_change_status
 } = util.api || {}


 export function saveContractTypeApi(params) {
    return http.post(contract_type_save, params)
}

export function getContractTypeListApi(params) {
    return http.get(contract_type_list, params)
}

export function changeStatusApi(params) {
    return http.post(contract_type_change_status, params)
}